export var ContentType;
(function (ContentType) {
    ContentType[ContentType["Video"] = 0] = "Video";
    ContentType[ContentType["Folder"] = 1] = "Folder";
    ContentType[ContentType["Playlist"] = 2] = "Playlist";
    ContentType[ContentType["Livestream"] = 3] = "Livestream";
    ContentType[ContentType["Fastchannels"] = 4] = "Fastchannels";
    ContentType[ContentType["ComingSoon"] = 5] = "ComingSoon";
    ContentType[ContentType["Reels"] = 6] = "Reels";
    ContentType[ContentType["Shorts"] = 7] = "Shorts";
    ContentType[ContentType["AllVideoType"] = 8] = "AllVideoType";
})(ContentType || (ContentType = {}));
export var PurchaseType;
(function (PurchaseType) {
    PurchaseType[PurchaseType["Buy"] = 0] = "Buy";
    PurchaseType[PurchaseType["Rent"] = 1] = "Rent";
    PurchaseType[PurchaseType["Subscribe"] = 2] = "Subscribe";
})(PurchaseType || (PurchaseType = {}));
// * =============================== [ GROUP LOOK ]
export var GroupTheme;
(function (GroupTheme) {
    GroupTheme[GroupTheme["Dark"] = 0] = "Dark";
    GroupTheme[GroupTheme["Light"] = 1] = "Light";
})(GroupTheme || (GroupTheme = {}));
//  =============================== [ Si riferisce al modello economico impostato al Cliente ]
export var GroupModelType;
(function (GroupModelType) {
    GroupModelType[GroupModelType["AD"] = 1] = "AD";
    GroupModelType[GroupModelType["SUB"] = 2] = "SUB";
    GroupModelType[GroupModelType["TVOD"] = 3] = "TVOD";
    GroupModelType[GroupModelType["PPV"] = 4] = "PPV";
    GroupModelType[GroupModelType["S_A"] = 5] = "S_A";
    GroupModelType[GroupModelType["S_PT"] = 6] = "S_PT";
    GroupModelType[GroupModelType["S_A_P_T"] = 7] = "S_A_P_T";
    GroupModelType[GroupModelType["S_C"] = 8] = "S_C";
    GroupModelType[GroupModelType["S_A_C"] = 9] = "S_A_C";
    GroupModelType[GroupModelType["ContentWidthAdvertising"] = 1] = "ContentWidthAdvertising";
    GroupModelType[GroupModelType["ContentBySubscription"] = 2] = "ContentBySubscription";
    GroupModelType[GroupModelType["TransactionalAccess"] = 3] = "TransactionalAccess";
    GroupModelType[GroupModelType["PayPerViewAccess"] = 4] = "PayPerViewAccess";
    GroupModelType[GroupModelType["SubscriptionWithAds"] = 5] = "SubscriptionWithAds";
    GroupModelType[GroupModelType["SubscriptionAndTransactional"] = 6] = "SubscriptionAndTransactional";
    GroupModelType[GroupModelType["SubscriptionWithAdsAndTransactional"] = 7] = "SubscriptionWithAdsAndTransactional";
    GroupModelType[GroupModelType["RechargableCreditAccess"] = 8] = "RechargableCreditAccess";
    GroupModelType[GroupModelType["RechargeableCreditAccesswithAds"] = 9] = "RechargeableCreditAccesswithAds";
})(GroupModelType || (GroupModelType = {}));
export var GroupMouseover;
(function (GroupMouseover) {
    GroupMouseover[GroupMouseover["Disabled"] = 0] = "Disabled";
    GroupMouseover[GroupMouseover["Enabled"] = 1] = "Enabled";
})(GroupMouseover || (GroupMouseover = {}));
export var GroupTitleAndDescription;
(function (GroupTitleAndDescription) {
    GroupTitleAndDescription[GroupTitleAndDescription["Disabled"] = 0] = "Disabled";
    GroupTitleAndDescription[GroupTitleAndDescription["Enabled"] = 1] = "Enabled";
})(GroupTitleAndDescription || (GroupTitleAndDescription = {}));
export var GroupPreviewPage;
(function (GroupPreviewPage) {
    GroupPreviewPage[GroupPreviewPage["Disabled"] = 0] = "Disabled";
    GroupPreviewPage[GroupPreviewPage["Enabled"] = 1] = "Enabled";
})(GroupPreviewPage || (GroupPreviewPage = {}));
export var GroupVodPreview;
(function (GroupVodPreview) {
    GroupVodPreview[GroupVodPreview["Disabled"] = 0] = "Disabled";
    GroupVodPreview[GroupVodPreview["Enabled"] = 1] = "Enabled";
})(GroupVodPreview || (GroupVodPreview = {}));
export var GroupNavbarItemType;
(function (GroupNavbarItemType) {
    GroupNavbarItemType[GroupNavbarItemType["Home"] = 0] = "Home";
    GroupNavbarItemType[GroupNavbarItemType["Catalogue"] = 1] = "Catalogue";
    GroupNavbarItemType[GroupNavbarItemType["News"] = 2] = "News";
    GroupNavbarItemType[GroupNavbarItemType["Schedule"] = 3] = "Schedule";
    GroupNavbarItemType[GroupNavbarItemType["BecomeArtist"] = 4] = "BecomeArtist";
    GroupNavbarItemType[GroupNavbarItemType["ContentsInEvidence"] = 5] = "ContentsInEvidence";
    GroupNavbarItemType[GroupNavbarItemType["Artists"] = 6] = "Artists";
    GroupNavbarItemType[GroupNavbarItemType["Shop"] = 7] = "Shop";
    GroupNavbarItemType[GroupNavbarItemType["CarouselHome"] = 8] = "CarouselHome";
    GroupNavbarItemType[GroupNavbarItemType["BabylonCoinShop"] = 9] = "BabylonCoinShop";
})(GroupNavbarItemType || (GroupNavbarItemType = {}));
export var UserRole;
(function (UserRole) {
    UserRole[UserRole["Guest"] = -1] = "Guest";
    UserRole[UserRole["User"] = 0] = "User";
    UserRole[UserRole["Artist"] = 1] = "Artist";
    UserRole[UserRole["Editor"] = 2] = "Editor";
    UserRole[UserRole["Admin"] = 3] = "Admin";
    UserRole[UserRole["Moderator"] = 4] = "Moderator";
    UserRole[UserRole["SuperAdmin"] = 5] = "SuperAdmin";
})(UserRole || (UserRole = {}));
// * =============================== [ HOMEPAGE SECTIONS ]
export var HomepageSectionType;
(function (HomepageSectionType) {
    HomepageSectionType[HomepageSectionType["Custom"] = -1] = "Custom";
    HomepageSectionType[HomepageSectionType["MainHeroSection"] = 0] = "MainHeroSection";
    HomepageSectionType[HomepageSectionType["Lives"] = 1] = "Lives";
    HomepageSectionType[HomepageSectionType["ComingSoon"] = 2] = "ComingSoon";
    HomepageSectionType[HomepageSectionType["Categories"] = 3] = "Categories";
    HomepageSectionType[HomepageSectionType["News"] = 4] = "News";
    HomepageSectionType[HomepageSectionType["SecondaryHeroSection"] = 5] = "SecondaryHeroSection";
    HomepageSectionType[HomepageSectionType["Reels"] = 6] = "Reels";
    HomepageSectionType[HomepageSectionType["Shorts"] = 7] = "Shorts";
})(HomepageSectionType || (HomepageSectionType = {}));
export var Orientation;
(function (Orientation) {
    Orientation[Orientation["Landscape"] = 0] = "Landscape";
    Orientation[Orientation["Portrait"] = 1] = "Portrait";
})(Orientation || (Orientation = {}));
// * =============================== [ HOMEPAGE SECTIONS ][ HERO SECTION ]
export var HeroSectionType;
(function (HeroSectionType) {
    HeroSectionType[HeroSectionType["Graphic"] = 0] = "Graphic";
    HeroSectionType[HeroSectionType["Content"] = 1] = "Content";
})(HeroSectionType || (HeroSectionType = {}));
export var HasMorePages;
(function (HasMorePages) {
    HasMorePages[HasMorePages["False"] = 0] = "False";
    HasMorePages[HasMorePages["True"] = 1] = "True";
})(HasMorePages || (HasMorePages = {}));
// * =============================== [ SWIPER ]
//classi cusom dello swiper in base alla vista
export var SwiperCustomClass;
(function (SwiperCustomClass) {
    SwiperCustomClass[SwiperCustomClass["Home"] = 0] = "Home";
    SwiperCustomClass[SwiperCustomClass["Viewmedia"] = 1] = "Viewmedia";
})(SwiperCustomClass || (SwiperCustomClass = {}));
